export default __webpack_public_path__ + "static/media/453361975119f25a938f7ccda4705f561629978229337.4f914732.webp";